export default __webpack_public_path__ + "static/media/button-minus.2aedef1b.svg";